export default __webpack_public_path__ + "static/media/hc-11.08c69c2c.mp4";